'use strict';

import './info_box.css';

import template from './info_box.html';

const saInfoBox = {
  template,
  bindings: {
    heading: '<?',
    description: '<?',
  },
};

export default angular.module('components.infoBox', [])
  .component('saInfoBox', saInfoBox)
  .name;



// WEBPACK FOOTER //
// ./app/src/modules/info_box/info_box.js